﻿import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers';

import styleVars_4 from "styles/colors.module.scss";
const { errorRed  } = styleVars_4;;

const DatePicker = forwardRef(
  ({ defaultValue, error, label, ...others }, ref) => {
    const [selectedDate, setSelectedDate] = useState(defaultValue ?? null);
    useEffect(() => {
      others.onChange?.(selectedDate);
    }, [selectedDate]);
    return (
      <div>
        <MUIDatePicker
          disableFuture
          openTo="day"
          format="MM/dd/yyyy"
          label={label}
          views={['year', 'month', 'day']}
          {...others}
          onChange={setSelectedDate}
          value={selectedDate}
          inputRef={ref}
        />
        {error && (
          <span style={{ display: 'block', color: errorRed }}>{error}</span>
        )}
      </div>
    );
  },
);

DatePicker.propTypes = {
  defaultValue: PropTypes.object,
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default DatePicker;
